import React from 'react';

import Partner from '../../../components/Molecules/Partner';

const NodePartner = ({ entity, className }) => (
  <Partner
    className={className}
    title={entity.getIn(['title', 0, 'value'], '')}
    link={entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']))}
    linkTitle={entity.getIn(['field_link', 0, 'title'], 'Over deze samenwerking')}
    image={entity.getIn(['field_logo', 0, 'url'])}
    imageAlt={entity.getIn(['field_logo', 0, 'alt'])}
    subTitle={entity.getIn(['field_subtitle', 0, 'value'], '')}
  />
);

export default NodePartner;
